import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: `${spacing.xl}px ${spacing.m}px`,
    },
    adjuster: {
      flexGrow: 1,
      justifyContent: "flex-end",
    },
    year: {
      marginLeft: spacing.s,
      marginRight: spacing.s,
      userSelect: "none",
      fontVariant: "tabular-nums",
    },
  };

  return styles;
};
